import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemo2Ctx } from '../Demo2Context';
import { STATUS_LABEL, STATUS_COLOR, treeIconRi } from '../demo2Data';

export default function Demo2MMoisture() {
    const navigate = useNavigate();
    const { zones } = useDemo2Ctx();
    const [q, setQ] = useState('');

    const list = useMemo(() => {
        const query = q.toLowerCase();
        return zones.filter(z => !query || z.name.toLowerCase().includes(query) || z.treeName.toLowerCase().includes(query))
            .sort((a, b) => a.moist - b.moist);
    }, [q, zones]);

    return (
        <>
            <div className="m-header"><div className="m-header-ttl">수분 상태 확인</div></div>
            <div className="m-body">
                <div className="m-body-p">
                    <div className="m-search">
                        <i className="ri-search-line m-search-ico" />
                        <input type="text" placeholder="구역명, 수종 검색..." value={q} onChange={e => setQ(e.target.value)} />
                    </div>
                    <div className="text-xs text-muted" style={{ marginBottom: 12, fontWeight: 600 }}><i className="ri-map-pin-line" /> 현재 위치 기준 반경 5km 이내 구역</div>
                    {list.length === 0 && (
                        <div className="d2-empty">
                            <i className="ri-search-line" />
                            <div className="d2-empty-txt">검색 결과가 없습니다</div>
                        </div>
                    )}
                    {list.map(z => {
                        const c = STATUS_COLOR[z.status];
                        return (
                            <div key={z.id} className="m-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/demo2/mobile/map')}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                                    <div className="d2-ico d2-ico-md d2-ico-green"><i className={treeIconRi(z.treeName)} /></div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: 13, fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{z.name}</div>
                                        <div style={{ fontSize: 10.5, color: 'var(--text3)', fontWeight: 600 }}>{z.category} · {z.treeName}</div>
                                    </div>
                                    <span className={`badge badge-${z.status}`} style={{ fontSize: 10, flexShrink: 0 }}>{STATUS_LABEL[z.status]}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                                    <div style={{ flex: 1, height: 6, background: 'var(--surface3)', borderRadius: 4, overflow: 'hidden' }}>
                                        <div style={{ width: `${z.moist}%`, height: '100%', background: c, borderRadius: 4 }} />
                                    </div>
                                    <span style={{ fontFamily: 'var(--mono)', fontWeight: 900, fontSize: 15, color: c, flexShrink: 0 }}>{z.moist}%</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
